// extracted by mini-css-extract-plugin
export default {"sizingSection":"SizingSection_sizingSection__Aeqxx"};